import useSWR from 'swr';
import {
  DocumentImageSize,
  DocumentTypeCode,
  EApiKey,
} from '@/studbook/constants';
import { Configuration, DocumentApi, DocumentDto } from '@/apiClient';

const apiConfiguration = new Configuration({
  basePath: process.env.NEXT_PUBLIC_API_URL,
});

const documentApi = new DocumentApi(apiConfiguration);

export default function useAnimalPrimaryImages(entityIds: number[]) {
  const { data, isLoading, error } = useSWR(
    () =>
      entityIds.length
        ? [EApiKey.GET_MULTIPLE_ENTITIES_MULTIPLE_IMAGES, entityIds]
        : null,
    () =>
      documentApi.apiDocumentGetAnimalImageByEntityIdGet(
        entityIds,
        DocumentTypeCode.Image,
        DocumentImageSize.thumb,
        true,
      ),
  );

  const multipleImgData = ((data?.data || []) as unknown as DocumentDto[]).map(
    (d) => ({
      entityGuid: d.entityId,
      imgUrl:
        d.documentBytes && d.documentBytes.length
          ? `data:image/png;base64, ${d.documentBytes}`
          : '',
    }),
  );

  return {
    multipleImgData,
    error,
    isLoading,
  };
}
